import { render, staticRenderFns } from "./facebook-login.vue?vue&type=template&id=6ca906ba&"
import script from "./facebook-login.vue?vue&type=script&lang=js&"
export * from "./facebook-login.vue?vue&type=script&lang=js&"
import style0 from "./facebook-login.vue?vue&type=style&index=0&id=6ca906ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports